<script setup lang="ts">
import { useRouter, useRoute } from 'vue-router';
import { reactive, onMounted } from 'vue'
import Overlay from '../Overlay.vue';
import PageTitle from '../controls/PageTitle.vue';
import AuthenticationApi from '../../sdk/AuthenticationApi';

const router = useRouter();
const route = useRoute();
const authApi = new AuthenticationApi();

const data = reactive({ 
  userRowKey: '',
  password: '',
  confirmPassword: '',
  updateInProgress: false,
  updateErrorOccurred: false,
  updateSuccessful: false,
  passwordMismatch: false,
})

onMounted(() => {
  data.userRowKey = route.params.rowKey as string;
});

const updatePasswordClicked = async function() {
    data.passwordMismatch = false;
    data.updateErrorOccurred = false;

    if (!data.password || !data.confirmPassword) {
        data.updateErrorOccurred = true;
        return;
    }

    if (data.password !== data.confirmPassword) {
        data.passwordMismatch = true;
        return;
    }

    try {
        data.updateInProgress = true;
        
        await authApi.updateUserPassword(data.userRowKey, data.password);
        
        data.updateInProgress = false;
        data.updateSuccessful = true;
    }
    catch(error) {
        data.updateInProgress = false;
        data.updateErrorOccurred = true;
        return;
    }
}

const backToLoginClicked = async function() {
    router.push({ name: "Login" });
}

</script>

<template>
  <div class="form-container">

    <PageTitle text="Neues Passwort setzen"></PageTitle>

    <div class="row">
      <div class="col-xs-12">
        <div class="box-row card cardshadow">
            <div v-if="!data.updateSuccessful">
                <p style="margin-bottom: 2rem; color: #666;">
                    Geben Sie Ihr neues Passwort ein und bestätigen Sie es.
                </p>
                
                <input 
                    type="password" 
                    name="password" 
                    id="password" 
                    class="textbox-style" 
                    v-model="data.password" 
                    placeholder="Neues Passwort"
                >

                <input 
                    type="password" 
                    name="confirmPassword" 
                    id="confirmPassword" 
                    class="textbox-style" 
                    v-model="data.confirmPassword" 
                    placeholder="Passwort bestätigen"
                    style="margin-top: 1rem;"
                >

                <button 
                    type="submit" 
                    name="updatePassword" 
                    class="buttonstyle" 
                    style="margin-top:2rem; margin-bottom: 1rem;" 
                    @click="updatePasswordClicked"
                >
                    <span>Passwort ändern</span>
                </button>
                
                <label v-if="data.updateErrorOccurred" class="label-style label-warning">
                    Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.
                </label>
                
                <label v-if="data.passwordMismatch" class="label-style label-warning">
                    Die Passwörter stimmen nicht überein.
                </label>
            </div>

            <div v-else class="success-message">
                <div style="color: var(--main-color); font-size: 1.6rem; margin-bottom: 2rem;">
                    ✓ Passwort erfolgreich geändert!
                </div>
                <p style="margin-bottom: 2rem; color: #666;">
                    Ihr Passwort wurde erfolgreich aktualisiert. Sie können sich jetzt mit Ihrem neuen Passwort anmelden.
                </p>
            </div>

            <div class="divider"></div>
            
            <button 
                type="submit" 
                name="backToLogin" 
                class="buttonstyle" 
                style="margin-top:2rem; margin-bottom: 1rem;" 
                @click="backToLoginClicked"
            >
                <span>Zum Login</span>
            </button>
        </div>
      </div>
    </div>

    <Overlay v-model:isvisible="data.updateInProgress" :is-closable="false" height="80px" width="200px" rounded-corners="0.5rem">
        <div style="display: flex;justify-content: center;align-items: center;height: 100%;">
            <div style="color: gray;">Passwort wird geändert...</div>
        </div>
    </Overlay>
  </div>
</template>

<style scoped>
.card {
  background-color: white;
  padding: 2rem
}

.divider {
  border-bottom: 1px solid lightgray;
  margin-top: 2rem;
  margin-bottom: 2rem;
}

.success-message {
  text-align: center;
}
</style>
